import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from "@angular/core";
import {IUser} from "../../../../../shared/redux-store/session/session.types";
import {AuthenticateUserResult, UserService} from "../../../../../crm/user/user.service";
import {SessionActions} from "../../../../../shared/actions/session.actions";
import {ApolloQueryObservable} from "apollo-angular";
import {AbstractVisbosComponent} from "../../../components/abstract-visbos.component";

@Component({
  selector: 'vb-user-identification',
  templateUrl: './user-identification.component.html',
  styleUrls: ['./user-identification.component.css']
})
export class UserIdentificationComponent extends AbstractVisbosComponent implements OnInit {

  private user$: ApolloQueryObservable<AuthenticateUserResult>;

  private user: IUser;
  private token: string;

  @Output()
  userIdentified: EventEmitter<IUser> = new EventEmitter();

  //TODO: Implement

  constructor(sessionActions: SessionActions, private userService: UserService, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit() {
  }


  identifyUser(credentials) {

  }

  onUserIdentified(user: IUser) {
    this.userIdentified.next(user);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/components/user-identification/user-identification.component.ts